import React from 'react';
import { createRoot } from 'react-dom/client';

// Импортируем глобальные стили
import './styles/global.css';

// Импортируем компоненты
import ProductCard from './components/ProductCard';
import CartDrawer from './components/CartDrawer';
import ProductRecommendations from './components/ProductRecommendations';
import Header from './components/Header';
import Hero from './components/Hero';
import PromoSection from './components/PromoSection';
import MenuCategories from './components/MenuCategories';
import MenuCatalog from './components/MenuCatalog';
import GoogleMap from './components/GoogleMap';
import ContactInfo from './components/ContactInfo';
import Footer from './components/Footer';
import AboutWelcome from './components/AboutWelcome';
import AboutRestaurant from './components/AboutRestaurant';
import AboutSpecialties from './components/AboutSpecialties';
import AboutInfoCards from './components/AboutInfoCards';
import AboutContact from './components/AboutContact';
import BanketteCatering from './components/BanketteCatering';
import BookingModal from './components/BookingModal';

// Инициализация React компонентов
document.addEventListener('DOMContentLoaded', function() {
  
  // Header
  const header = document.querySelector('[data-react-header]');
  if (header) {
    const settings = JSON.parse(header.dataset.settings || '{}');
    const logoUrl = header.dataset.logoUrl || '';
    const root = createRoot(header);
    root.render(<Header settings={settings} logoUrl={logoUrl} />);
  }

  // Hero
  const hero = document.querySelector('[data-react-hero]');
  if (hero) {
    const settings = JSON.parse(hero.dataset.settings || '{}');
    
    const root = createRoot(hero);
    root.render(<Hero settings={settings} />);
  }

  // Promo Section
  const promoSection = document.querySelector('[data-react-promo]');
  if (promoSection) {
    const settings = JSON.parse(promoSection.dataset.settings || '{}');
    const backgroundImageUrl = promoSection.dataset.backgroundImageUrl || '';
    const root = createRoot(promoSection);
    root.render(<PromoSection settings={settings} backgroundImageUrl={backgroundImageUrl} />);
  }

  // Menu Categories
  const menuCategories = document.querySelector('[data-react-menu-categories]');
  if (menuCategories) {
    const settings = JSON.parse(menuCategories.dataset.settings || '{}');
    const root = createRoot(menuCategories);
    root.render(<MenuCategories settings={settings} />);
  }

  // Menu Catalog
  const menuCatalog = document.querySelector('.react-menu-catalog');
  if (menuCatalog) {
    const pageTitle = menuCatalog.dataset.pageTitle || 'MENU';
    const pageDescription = menuCatalog.dataset.pageDescription || '';
    const showSearch = menuCatalog.dataset.showSearch === 'true';
    const searchPlaceholder = menuCatalog.dataset.searchPlaceholder || 'Search...';
    const showFilter = menuCatalog.dataset.showFilter === 'true';
    const showSort = menuCatalog.dataset.showSort === 'true';
    const itemsPerPage = parseInt(menuCatalog.dataset.itemsPerPage) || 12;
    
    const settings = {
      pageTitle,
      pageDescription,
      showSearch,
      searchPlaceholder,
      showFilter,
      showSort,
      itemsPerPage
    };
    
    const root = createRoot(menuCatalog);
    root.render(<MenuCatalog settings={settings} />);
  }



  // Google Map
  const googleMaps = document.querySelectorAll('.react-google-map');
  googleMaps.forEach(container => {
    const mapUrl = container.dataset.mapUrl || '';
    const mapTitle = container.dataset.mapTitle || 'Our Location';
    const mapHeight = parseInt(container.dataset.mapHeight) || 450;
    const borderRadius = parseInt(container.dataset.borderRadius) || 10;
    const showTitle = container.dataset.showTitle === 'true';
    const showShadow = container.dataset.showShadow === 'true';
    const mapWidth = container.dataset.mapWidth || 'container';
    const customWidth = parseInt(container.dataset.customWidth) || 80;
    const backgroundColor = container.dataset.backgroundColor || '#ffffff';
    const titleColor = container.dataset.titleColor || '#2c2c2c';
    const sectionPaddingTop = parseInt(container.dataset.sectionPaddingTop) || 40;
    const sectionPaddingBottom = parseInt(container.dataset.sectionPaddingBottom) || 40;
    const shadowStyle = container.dataset.shadowStyle || 'medium';
    
    const root = createRoot(container);
    root.render(<GoogleMap 
      mapUrl={mapUrl}
      title={mapTitle}
      height={mapHeight}
      borderRadius={borderRadius}
      showTitle={showTitle}
      showShadow={showShadow}
      mapWidth={mapWidth}
      customWidth={customWidth}
      backgroundColor={backgroundColor}
      titleColor={titleColor}
      sectionPaddingTop={sectionPaddingTop}
      sectionPaddingBottom={sectionPaddingBottom}
      shadowStyle={shadowStyle}
    />);
  });

  // Contact Info
  const contactInfos = document.querySelectorAll('.react-contact-info');
  contactInfos.forEach(container => {
    const phone = container.dataset.phone || '';
    const email = container.dataset.email || '';
    const address = container.dataset.address || '';
    const hours = container.dataset.hours || '';
    const showForm = container.dataset.showForm === 'true';
    const formTitle = container.dataset.formTitle || 'Contact Us';
    const contactTitle = container.dataset.contactTitle || 'CONTACTS';
    const socialTitle = container.dataset.socialTitle || 'FOLLOW US';
    const submitText = container.dataset.submitText || 'SUBMIT';
    
    // Универсальные социальные сети (социальные элементы 1-5)
    const social1Url = container.dataset.social1Url || '';
    const social1Title = container.dataset.social1Title || '';
    const social1Type = container.dataset.social1Type || '';
    const social2Url = container.dataset.social2Url || '';
    const social2Title = container.dataset.social2Title || '';
    const social2Type = container.dataset.social2Type || '';
    const social3Url = container.dataset.social3Url || '';
    const social3Title = container.dataset.social3Title || '';
    const social3Type = container.dataset.social3Type || '';
    const social4Url = container.dataset.social4Url || '';
    const social4Title = container.dataset.social4Title || '';
    const social4Type = container.dataset.social4Type || '';
    const social5Url = container.dataset.social5Url || '';
    const social5Title = container.dataset.social5Title || '';
    const social5Type = container.dataset.social5Type || '';
    
    // Создаем объект settings для компонента
    const settings = {
      phone: phone,
      email: email,
      address: address,
      hours: hours,
      showForm: showForm,
      formTitle: formTitle,
      contactTitle: contactTitle,
      socialTitle: socialTitle,
      submitText: submitText,
      showAddress: true,
      showPhone: true,
      showHours: true,
      showEmail: true,
      // Универсальные социальные сети
      social1Url: social1Url,
      social1Title: social1Title,
      social1Type: social1Type,
      social2Url: social2Url,
      social2Title: social2Title,
      social2Type: social2Type,
      social3Url: social3Url,
      social3Title: social3Title,
      social3Type: social3Type,
      social4Url: social4Url,
      social4Title: social4Title,
      social4Type: social4Type,
      social5Url: social5Url,
      social5Title: social5Title,
      social5Type: social5Type
    };
    
    const root = createRoot(container);
    root.render(<ContactInfo settings={settings} />);
  });
  
  // Product Cards
  const productCards = document.querySelectorAll('[data-react-product-card]');
  productCards.forEach(element => {
    const productData = JSON.parse(element.dataset.product || '{}');
    const root = createRoot(element);
    root.render(<ProductCard product={productData} />);
  });

  // Cart Drawer
  const cartDrawer = document.querySelector('[data-react-cart-drawer]');
  if (cartDrawer) {
    const root = createRoot(cartDrawer);
    root.render(<CartDrawer />);
  }

  // Product Recommendations
  const recommendations = document.querySelectorAll('[data-react-recommendations]');
  recommendations.forEach(element => {
    const productId = element.dataset.productId;
    const root = createRoot(element);
    root.render(<ProductRecommendations productId={productId} />);
  });

  // Footer
  const footer = document.querySelector('[data-react-footer]');
  if (footer) {

    const settings = JSON.parse(footer.dataset.settings || '{}');

    const root = createRoot(footer);
    root.render(<Footer 
      brandTitle={settings.brand_title || 'DAMAS'}
      brandDescription={settings.brand_description}
      phone={settings.phone || '043 818 29 12'}
      email={settings.email}
      address={settings.address || 'Kyburgstrasse 28\n8037 Zürich'}
      tripadvisorUrl={settings.tripadvisorUrl}
      facebookUrl={settings.facebookUrl}
      yelpUrl={settings.yelpUrl}
      justeatUrl={settings.justeatUrl}
      smoodUrl={settings.smoodUrl}
      instagramUrl={settings.instagramUrl}
      copyrightText={settings.copyrightText}
      showPaymentIcons={settings.showPaymentIcons !== false}
    />);
  } 

  // About Welcome
  const aboutWelcome = document.querySelector('[data-react-about-welcome]');
  if (aboutWelcome) {
    const settings = JSON.parse(aboutWelcome.dataset.settings || '{}');
    const root = createRoot(aboutWelcome);
    root.render(<AboutWelcome settings={settings} />);
  }

  // About Restaurant
  const aboutRestaurant = document.querySelector('[data-react-about-restaurant]');
  if (aboutRestaurant) {
    const settings = JSON.parse(aboutRestaurant.dataset.settings || '{}');
    const root = createRoot(aboutRestaurant);
    root.render(<AboutRestaurant settings={settings} />);
  }

  // About Specialties
  const aboutSpecialties = document.querySelector('[data-react-about-specialties]');
  if (aboutSpecialties) {
    const settings = JSON.parse(aboutSpecialties.dataset.settings || '{}');
    const root = createRoot(aboutSpecialties);
    root.render(<AboutSpecialties settings={settings} />);
  }

  // About Info Cards
  const aboutInfoCards = document.querySelector('[data-react-about-info-cards]');
  if (aboutInfoCards) {
    const settings = JSON.parse(aboutInfoCards.dataset.settings || '{}');
    const root = createRoot(aboutInfoCards);
    root.render(<AboutInfoCards settings={settings} />);
  }

  // About Contact
  const aboutContact = document.querySelector('[data-react-about-contact]');
  if (aboutContact) {
    const settings = JSON.parse(aboutContact.dataset.settings || '{}');
    const root = createRoot(aboutContact);
    root.render(<AboutContact settings={settings} />);
  }

  // Bankette Catering
  const banketteCatering = document.querySelector('#bankette-catering-section');
  if (banketteCatering) {
    const settings = JSON.parse(banketteCatering.dataset.settings || '{}');
    const root = createRoot(banketteCatering);
    root.render(<BanketteCatering settings={settings} />);
  }

  // Booking Modal (для Banquets сторінки)
  const banquetsBookingModal = document.querySelector('[data-react-booking-modal]');
  if (banquetsBookingModal) {
    const root = createRoot(banquetsBookingModal);
    
    // Створюємо контейнер для модалки
    const BookingModalWrapper = () => {
      const [isOpen, setIsOpen] = React.useState(false);
      
      // Глобальна функція для відкриття модалки
      React.useEffect(() => {
        window.openReactBookingModal = () => setIsOpen(true);
        return () => {
          delete window.openReactBookingModal;
        };
      }, []);
      
      return <BookingModal isOpen={isOpen} onClose={() => setIsOpen(false)} />;
    };
    
    root.render(<BookingModalWrapper />);
  }

});

// Экспортируем для использования в других местах
window.ReactComponents = {
  ProductCard,
  CartDrawer,
  ProductRecommendations,
  Header,
  Hero,
  PromoSection,
  MenuCategories,
  MenuCatalog,
  GoogleMap,
  ContactInfo,
  Footer,
  AboutWelcome,
  AboutRestaurant,
  AboutSpecialties,
  AboutInfoCards,
  AboutContact,
  BanketteCatering,
  BookingModal
};